// Tiny pub-sub so any fetch call site (spread across many hook files, outside
// React component tree) can report a mid-session 401 without importing the
// auth context directly. AuthProvider (useAuth.ts) subscribes once and clears
// its user state, which flips AuthGate (App.tsx) to the Login screen for the
// whole app.
//
// Why this exists: the independent design review of the RBAC session-
// staleness fix (2026-07-07, BLOCK finding) found that when a session is
// destroyed mid-session — the 24h GROUP_REVALIDATION_MS boundary, or the
// one-time mass logout at deploy — the SPA had no global 401 handling.
// AuthProvider only checked auth once on mount; every data-fetching hook just
// threw/displayed its own "HTTP 401" independently while the shell kept
// rendering as logged-in. This module + apiFetch.ts close that gap with one
// forced, clean re-login instead of a confusing partial-failure state.
type Listener = () => void;
const listeners = new Set<Listener>();

/** Subscribe to unauthorized (401) events. Returns an unsubscribe function. */
export function onUnauthorized(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Report a 401 seen by any fetch call site. */
export function reportUnauthorized(): void {
  for (const l of listeners) l();
}
